module.exports = __webpack_public_path__ + "static/media/instagramStory.edc31b01.jpeg";